import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskSlaSettingsRoute: InvariantJiraRoute = {
	name: 'servicedesk-sla-settings',
	path: '/jira/servicedesk/projects/:projectKey/settings/sla/(custom|new)?/:id?/(edit)?',
};
